import { Typography } from 'antd';
import styles from './SheetLinkedAccountItem.module.css';
import AssetLogo from './AssetLogo';

type SheetLinkedAccountItemType = {
  showImage?: boolean;
  fipId: string;
  fipName: string;
  accNo?: string;
  label?: string;
};

const SheetLinkedAccountItem = ({
  showImage = false,
  fipId,
  fipName,
  accNo,
  label,
}: SheetLinkedAccountItemType) => {
  const { Text } = Typography;

  return (
    <div className={styles.linkedAccountLeft}>
      {showImage && (
        <div className={styles.linkedAccountLogo}>
          <AssetLogo
            imageId={fipId}
            assetType='BANK'
            width={'100%'}
            height={'100%'}
            fallback={{
              path: 'images/bank-default.svg',
              type: 'IMAGE',
              className: styles.linkedAccountLogoImg,
            }}
          />
        </div>
      )}

      <div className={styles.linkedAccountInfo}>
        <Text className={styles.linkedAccountName}>{fipName}</Text>
        {label && <Text className={styles.linkedAccountNumber}>{label}</Text>}
        {accNo && (
          <Text className={styles.linkedAccountNumber}>
            XXXX {accNo.slice(-4)}
          </Text>
        )}
      </div>
    </div>
  );
};

export default SheetLinkedAccountItem;
